// eventBus.js
import Vue from 'vue';
export const EventBus = new Vue();




// WEBPACK FOOTER //
// C:/Users/cesar/Documents/dev/LMSEDK/LMSDEKTernium-clone/D:/dev/LMSEDK/LMSDEKTernium-clone/src/modules/eventBus.js